import React from "react";

function SearchScreenerHeading({ responseId, screenerToken, surveyName, category }) {
  if (!responseId) return null;

  return (
    <div className="search-screener-heading">
      <div>
        <a
          className="back screener-header-text"
          href={screenerToken ? `/assessments/response_sets/${screenerToken}` : "/my211/screeners"}
        >
          Back to {surveyName || ""} Screener
        </a>
      </div>
      <div className="survey-title screener-heading">
        Save Resources
        {category && (
          <>
            {" "}for <b>{category}</b>
          </>
        )}
      </div>
    </div>
  );
}

export default SearchScreenerHeading;
